export default __webpack_public_path__ + "static/media/Kannada_book_m.322155ef.wav";